import Header from "./header";
import Footer from "./footer";
import MagnificPopup from "./magnific-popup";
import Slick from "./slick";

import CountDown from "./count-down";
import SelectPrice from "./select-price";
import WatchButton from "./watch-button";
import ProductImage from "./product-image";
import HighestBid from "./highest-Bid";
import BidHistory from "./bid-history";
import Login from "./login";
import TopMenu from "./top-menu";
import UserProfile from "./user-profile";
import UserProfileOffcanvas from "./user-profile-offcanvas";
import UserListButtons from "./user-list-buttons";
import MinBid from "./min-bid";

export default {
    Header,
    Footer,
    MagnificPopup,
    Slick,
    CountDown,
    SelectPrice,
    WatchButton,
    ProductImage,
    HighestBid,
    BidHistory,
    Login,
    TopMenu,
    UserProfile,
    UserProfileOffcanvas,
    UserListButtons,
    MinBid
}